<template>
  <div class="ios-switch-row" :class="{ 'ios-switch-row--last': last }">
    <div class="switch-left">
      <div v-if="$slots.icon" class="switch-icon">
        <slot name="icon"></slot>
      </div>
      <div class="switch-label-wrap">
        <div class="switch-label">{{ label }}</div>
        <div v-if="subtitle" class="switch-subtitle">{{ subtitle }}</div>
      </div>
    </div>
    <label class="ios-toggle">
      <input 
        type="checkbox" 
        :checked="modelValue" 
        @change="handleChange"
      />
      <span class="toggle-slider"></span>
    </label>
  </div>
</template>

<script setup lang="ts">
defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  label: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    default: ''
  },
  last: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue']);

const handleChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  emit('update:modelValue', target.checked);
};
</script>

<style lang="scss" scoped>
.ios-switch-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  min-height: 44px;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 16px;
    right: 16px;
    height: 1px;
    background: linear-gradient(90deg,
      transparent 0%,
      rgba(var(--v-theme-sheetText), 0.1) 20%,
      rgba(var(--v-theme-sheetText), 0.1) 80%,
      transparent 100%);
  }
  
  &--last::after {
    display: none;
  }
}

.switch-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.switch-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(var(--v-theme-sheetText), 0.12);
}

.switch-label {
  font-size: 1rem;
  color: rgb(var(--v-theme-sheetText));
}

.switch-subtitle {
  font-size: 0.8rem;
  color: rgba(var(--v-theme-sheetText), 0.5);
  margin-top: 2px;
}

.ios-toggle {
  position: relative;
  display: inline-block;
  width: 51px;
  height: 31px;
  flex-shrink: 0;
  
  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(var(--v-theme-sheetText), 0.2);
  transition: 0.3s;
  border-radius: 31px;
  
  &::before {
    position: absolute;
    content: "";
    height: 27px;
    width: 27px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
}

input:checked + .toggle-slider {
  background-color: rgb(var(--v-theme-success));
}

input:checked + .toggle-slider::before {
  transform: translateX(20px);
}
</style>
